import type { HTMLAttributes, JSX } from 'react'

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  size?: 'sm' | 'md' | 'lg'
}

export function Spinner({ size = 'md', className = '', ...props }: SpinnerProps): JSX.Element {
  const sizeClass = size !== 'md' ? `fui-spinner-${size}` : ''
  const classes = ['fui-spinner', sizeClass, className].filter(Boolean).join(' ')

  return <span className={classes} role="status" aria-label="Loading" {...props} />
}
